import * as t from 'io-ts'
import { TransactionType } from '../TransactionType'
import { Maybe } from '@mxt/zio/codec'

export const ZaloRequestProcess = t.type({
  transactionType: t.literal(TransactionType.ZALO_REQUEST_PROCESS),
  payload: t.type({
    body: t.type({
      message: Maybe(t.string)
    })
  })
})
export type ZaloRequestProcess = t.TypeOf<typeof ZaloRequestProcess>
